import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { UserService } from '../services/user.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
	constructor(private userService: UserService) {}

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const currentUser = this.userService.currentUserValue;
		const isLoggedIn = currentUser && currentUser.token;
		const apiOrigin = environment.apiUrl.replace(/\/api\/?$/, '');
		const isApiUrl = request.url.startsWith(environment.apiUrl) || request.url.startsWith(`${apiOrigin}/oauth/`);
		const isMSLoginUrl = request.url.includes('authentication/mslogin');
		if (isApiUrl) {
			// Identifies this browser so signing in here replaces this browser's own previous
			// session and leaves the same user's other devices alone. Sent on every API call
			// rather than only on sign-in, because the sign-in endpoints take three different
			// request shapes and the session paths all need it.
			request = request.clone({ setHeaders: { 'X-Device-Id': this.userService.deviceId } });

			var token = '';
			if (isMSLoginUrl) {
				token = this.userService.getMsalAccessToken();
				request = request.clone({
					setHeaders: {
						Authorization: `Bearer ${token}`,
					},
				});
			} else if (isLoggedIn) {
				token = currentUser.token;
				request = request.clone({
					setHeaders: {
						Authorization: `Bearer ${token}`,
					},
				});
			}
		}

		return next.handle(request);
	}
}
